import React from 'react';
import { withStyles } from '@material-ui/core';

const styles = {
  container: {
    maxWidth: '600px',
  },
  chip: {
    display: 'inline-block',
    fontSize: '14px',
    fontWeight: 400,
    color: 'rgba(0,0,0,0.87)',
    padding: '2px 12px',
    marginRight: '8px',
    marginTop: '1px',
    marginBottom: '1px',
    borderRadius: '4px',
    backgroundColor: '#F8F8F8',
  },
};

const LanguageChips = ({ classes, data }) => {
  const languages = Object.values(data).map(value => value.language.replace('/languages/', ''));
  return (
    <div className={classes.container}>
      {
        languages.map(language => <span className={classes.chip} key={language}>{language}</span>)
      }
    </div>
  );
};

export default withStyles(styles)(LanguageChips);
